import React from 'react';

const TABS = [
  { key: 'home', label: 'Home', icon: HomeIcon },
  { key: 'packages', label: 'Packages', icon: BoxIcon },
  { key: 'pools', label: 'Pools', icon: PoolIcon },
  { key: 'team', label: 'Team', icon: TeamIcon },
  { key: 'activity', label: 'History', icon: HistoryIcon },
];

const ADMIN_TAB = { key: 'admin', label: 'Admin', icon: ShieldIcon };

export default function BottomNav({ active, onChange, showAdmin }) {
  const tabs = showAdmin ? [...TABS, ADMIN_TAB] : TABS;
  return (
    <nav className="bottom-nav">
      {tabs.map((t) => {
        const Icon = t.icon;
        const on = active === t.key;
        return (
          <button
            key={t.key}
            className={`nav-item ${on ? 'active' : ''}`}
            onClick={() => onChange(t.key)}
          >
            <span className="nav-ic">
              <Icon active={on} />
            </span>
            {t.label}
          </button>
        );
      })}
    </nav>
  );
}

const stroke = (a) => (a ? '#f5c518' : '#6b7488');

function HomeIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M3 10.5 12 3l9 7.5" stroke={stroke(active)} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 9.5V20h14V9.5" stroke={stroke(active)} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function BoxIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M12 3 21 7.5v9L12 21 3 16.5v-9L12 3Z" stroke={stroke(active)} strokeWidth="2" strokeLinejoin="round" />
      <path d="M3 7.5 12 12l9-4.5M12 12v9" stroke={stroke(active)} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
function PoolIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M12 2 4 7l8 5 8-5-8-5Z" stroke={stroke(active)} strokeWidth="2" strokeLinejoin="round" />
      <path d="M4 12l8 5 8-5M4 17l8 5 8-5" stroke={stroke(active)} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
function TeamIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="8" r="3.2" stroke={stroke(active)} strokeWidth="2" />
      <path d="M3.5 20c0-3 2.5-5 5.5-5s5.5 2 5.5 5" stroke={stroke(active)} strokeWidth="2" strokeLinecap="round" />
      <path d="M16 5.5a3 3 0 0 1 0 6M17.5 20c0-2-.7-3.6-2-4.7" stroke={stroke(active)} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
function HistoryIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke={stroke(active)} strokeWidth="2" />
      <path d="M12 7v5l3.5 2" stroke={stroke(active)} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function ShieldIcon({ active }) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M12 3l7 3v5c0 4.4-3 8-7 10-4-2-7-5.6-7-10V6l7-3Z" stroke={stroke(active)} strokeWidth="2" strokeLinejoin="round" />
      <path d="M9 12l2 2 4-4" stroke={stroke(active)} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
